export default __webpack_public_path__ + "static/N0286-0a53eb4855036953d111af36cfe6a094.png";